import { DraggedSingleData } from "../../../../../components/ui/DragToolsUI";
import BaseScenarioPart from "../../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { constants } from "../../../../../misc/constants";
import { forceRerenderUI } from "../../../../../misc/tools";
import { DaarcBaseScenario } from "../../../../DaarcBaseScenario";
import { GeneralProceduresCricPart1Config, GeneralProceduresCricMainConfig } from "../GeneralProceduresCricMain";

var alreadyAdded = false;
export default class GeneralProceduresCricPart1 extends BaseScenarioPart<DaarcBaseScenario> {
	private get config(): GeneralProceduresCricPart1Config {
		return this.scenarioConfig.part1Config;
	}
	constructor(private _scenario: DaarcBaseScenario, private onDone: () => void, private id: string, private scenarioConfig: GeneralProceduresCricMainConfig) {
		super(_scenario);
	}

	public get partId(): string {
		return this.id;
	}

	public get videoUrl(): string[] {
		return [this.config.videoUrl];
	}

	public start() {
		const context = this;
		context.scenario.uiWrapper.displayDragToolsUI({
			onIncorrectToolPicked: () => {
				context.scenario.uiWrapper.displayGeneralAlertUI({
					title: 'Incorrect',
					text: 'This tool placement is incorrect',
					okButton: {
						title: 'OK',
						onClicked: () => {}
					}
				});
			},
			onToolsArranged: (text: string[], data: DraggedSingleData[]) => {
				var isCorrect = true;

				for(var indx = 0; indx < text.length; indx++) {
					if(text[indx] !== context.config.correctToolOrder[indx]) {
						isCorrect = false;
						break;
					}
				}

				if(!isCorrect) {
					context._scenario.arrangeCricToolsPoints = 100;
				}

				if(context.scenarioConfig.isCricScenario && !alreadyAdded) {
					context._scenario.addScore(context.scenario.arrangeCricToolsPoints);
					alreadyAdded = true;
				}
				context.onDone();
				context._scenario.uiWrapper.destroyAllUIInstances();
				forceRerenderUI(constants.uiNames.DraggedToolsUI);
			},
			onClose: () => {
				// context.scenario.toolbagId = context.scenario.uiWrapper.displayToolbag({
				// 	isDisabled: false
				// }, context.scenario.toolbagId);
				forceRerenderUI(constants.uiNames.DraggedToolsUI);
			},
			toolsToChooseFrom: [
				constants.cricTools.bougie,
				constants.cricTools.ett,
				constants.cricTools.scalpel,
				constants.cricTools.spreader,
				constants.cricTools.syringe
			],
			correctToolOrder: [
				constants.cricTools.scalpel,
				constants.cricTools.spreader,
				constants.cricTools.bougie,
				constants.cricTools.ett,
				constants.cricTools.syringe
			]
		}); 
	}
}